import { ColorVariants } from "libs/components/src/lib/models";

interface FirstBackgroundProps {
  color: ColorVariants;
  className?: string;
}

const FirstBackground = ({ color, className }: FirstBackgroundProps) => {
  let primary = "";
  let secondary = "";
  switch (color) {
    case "TEAL":
      primary = "#61D5EE";
      secondary = "#30AFD3";
      break;

    case "ORANGE":
      primary = "#FEB45E";
      secondary = "#F0A349";
      break;

    case "GREEN":
      primary = "#3CBB73";
      secondary = "#229B56";
      break;

    case "PURPLE":
      primary = "#7B60FA";
      secondary = "#6349DE";
      break;

    case "PINK":
      primary = "#F86498";
      secondary = "#D65280";
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      width="352"
      height="182"
      viewBox="0 0 352 182"
      fill="none"
      className={className}
    >
      <g mask="url(#mask0_5720_94548)">
        <rect width="352" height="182" fill={primary} />
        <path
          d="M48.5 12.7161C76.9 -33.2839 150.667 -31.1172 184 -24.2839L234.957 -8.13366C240.442 -7.86181 244.894 -6.50841 248 -4L234.957 -8.13366C202.181 -9.75832 132.564 27.2497 93.5 87.2161C47.9 157.216 -72.1667 166.833 -121 162L-115.5 148.716C-64.5 157.216 13 70.2161 48.5 12.7161Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M364.5 177C254.5 82.9999 -1.78959 144.667 -18.5 182.5L197 231L364.5 177Z"
          fill={secondary}
        />
        <g clipPath="url(#clip0_5720_94548)">
          <rect
            x="241.864"
            y="28.516"
            width="99.1358"
            height="116.484"
            rx="10"
            fill="white"
          />
          <line
            x1="225.018"
            y1="145.214"
            x2="361.16"
            y2="9.07221"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="222.949"
            y1="143.145"
            x2="359.091"
            y2="7.00348"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="220.88"
            y1="141.076"
            x2="357.022"
            y2="4.93476"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="218.812"
            y1="139.007"
            x2="354.954"
            y2="2.86591"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="216.744"
            y1="136.939"
            x2="352.885"
            y2="0.79706"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="214.675"
            y1="134.87"
            x2="350.816"
            y2="-1.27167"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="227.087"
            y1="147.282"
            x2="363.229"
            y2="11.1408"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="229.155"
            y1="149.351"
            x2="365.297"
            y2="13.2098"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="231.225"
            y1="151.42"
            x2="367.366"
            y2="15.2785"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="233.293"
            y1="153.489"
            x2="369.435"
            y2="17.3472"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="235.362"
            y1="155.557"
            x2="371.504"
            y2="19.4158"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="237.431"
            y1="157.626"
            x2="373.572"
            y2="21.4847"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="239.499"
            y1="159.695"
            x2="375.641"
            y2="23.5535"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="241.568"
            y1="161.764"
            x2="377.71"
            y2="25.6223"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="253.981"
            y1="174.176"
            x2="390.122"
            y2="38.0347"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="251.912"
            y1="172.107"
            x2="388.054"
            y2="35.9659"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="249.843"
            y1="170.039"
            x2="385.985"
            y2="33.8972"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="247.774"
            y1="167.97"
            x2="383.916"
            y2="31.8286"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="245.706"
            y1="165.901"
            x2="381.848"
            y2="29.7596"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="243.637"
            y1="163.833"
            x2="379.779"
            y2="27.691"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="256.049"
            y1="176.245"
            x2="392.191"
            y2="40.1035"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="258.118"
            y1="178.314"
            x2="394.26"
            y2="42.1722"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="260.187"
            y1="180.382"
            x2="396.329"
            y2="44.2409"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="262.256"
            y1="182.451"
            x2="398.397"
            y2="46.3096"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="264.324"
            y1="184.52"
            x2="400.466"
            y2="48.3785"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="266.393"
            y1="186.589"
            x2="402.535"
            y2="50.4473"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="268.462"
            y1="188.658"
            x2="404.603"
            y2="52.5159"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="270.531"
            y1="190.726"
            x2="406.672"
            y2="54.5847"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="291.773"
            y1="194.546"
            x2="418.246"
            y2="68.0724"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="289.704"
            y1="192.477"
            x2="416.177"
            y2="66.0037"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="287.635"
            y1="190.408"
            x2="414.108"
            y2="63.935"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="285.566"
            y1="188.34"
            x2="412.04"
            y2="61.8661"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="283.498"
            y1="186.271"
            x2="409.971"
            y2="59.7974"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="281.429"
            y1="184.202"
            x2="407.903"
            y2="57.7286"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="293.842"
            y1="196.615"
            x2="420.315"
            y2="70.141"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="295.91"
            y1="198.683"
            x2="422.383"
            y2="72.2099"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="297.979"
            y1="200.752"
            x2="424.452"
            y2="74.2787"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="300.048"
            y1="202.821"
            x2="426.521"
            y2="76.3475"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="302.117"
            y1="204.89"
            x2="428.59"
            y2="78.4161"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="304.185"
            y1="206.958"
            x2="430.659"
            y2="80.4849"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="306.254"
            y1="209.027"
            x2="432.727"
            y2="82.5536"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="308.323"
            y1="211.096"
            x2="434.796"
            y2="84.6224"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="320.735"
            y1="223.508"
            x2="447.209"
            y2="97.0348"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="318.666"
            y1="221.44"
            x2="445.14"
            y2="94.9661"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="316.598"
            y1="219.371"
            x2="443.071"
            y2="92.8974"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="314.529"
            y1="217.302"
            x2="441.002"
            y2="90.8287"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="312.46"
            y1="215.233"
            x2="438.934"
            y2="88.7598"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="310.392"
            y1="213.165"
            x2="436.865"
            y2="86.6912"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="322.804"
            y1="225.577"
            x2="449.277"
            y2="99.1037"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="324.872"
            y1="227.646"
            x2="451.346"
            y2="101.172"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="326.941"
            y1="229.715"
            x2="453.415"
            y2="103.241"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="329.01"
            y1="231.783"
            x2="455.484"
            y2="105.31"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="331.079"
            y1="233.852"
            x2="457.552"
            y2="107.379"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="333.147"
            y1="235.921"
            x2="459.621"
            y2="109.447"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="335.216"
            y1="237.99"
            x2="461.69"
            y2="111.516"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="337.285"
            y1="240.058"
            x2="463.759"
            y2="113.585"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="147.7"
            y1="59.0596"
            x2="274.173"
            y2="-67.4139"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="144.579"
            y1="55.9388"
            x2="271.052"
            y2="-70.5348"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="141.458"
            y1="52.8178"
            x2="267.931"
            y2="-73.6557"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="138.337"
            y1="49.6969"
            x2="264.811"
            y2="-76.7766"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="135.216"
            y1="46.5761"
            x2="261.69"
            y2="-79.8974"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="132.095"
            y1="43.4552"
            x2="258.569"
            y2="-83.0183"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="150.821"
            y1="62.1805"
            x2="277.294"
            y2="-64.2931"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="153.941"
            y1="65.3013"
            x2="280.415"
            y2="-61.1722"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="157.062"
            y1="68.4223"
            x2="283.536"
            y2="-58.0512"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="160.183"
            y1="71.5431"
            x2="286.657"
            y2="-54.9304"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="163.304"
            y1="74.664"
            x2="289.778"
            y2="-51.8095"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="166.425"
            y1="77.7848"
            x2="292.898"
            y2="-48.6887"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="169.546"
            y1="80.9057"
            x2="296.019"
            y2="-45.5678"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="172.666"
            y1="84.0265"
            x2="299.14"
            y2="-42.447"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="191.392"
            y1="102.752"
            x2="317.866"
            y2="-23.7216"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="188.271"
            y1="99.6309"
            x2="314.744"
            y2="-26.8426"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="185.15"
            y1="96.5101"
            x2="311.623"
            y2="-29.9635"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="182.029"
            y1="93.3892"
            x2="308.503"
            y2="-33.0843"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="178.909"
            y1="90.2684"
            x2="305.382"
            y2="-36.2052"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="175.788"
            y1="87.1475"
            x2="302.261"
            y2="-39.326"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="194.513"
            y1="105.873"
            x2="320.986"
            y2="-20.6008"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="197.634"
            y1="108.994"
            x2="324.107"
            y2="-17.4799"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="200.754"
            y1="112.114"
            x2="327.228"
            y2="-14.3591"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="203.875"
            y1="115.235"
            x2="330.349"
            y2="-11.2382"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="206.997"
            y1="118.356"
            x2="333.47"
            y2="-8.11739"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="210.117"
            y1="121.477"
            x2="336.591"
            y2="-4.99642"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="213.238"
            y1="124.598"
            x2="339.711"
            y2="-1.87557"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="216.359"
            y1="127.719"
            x2="342.832"
            y2="1.24528"
            stroke="black"
            strokeWidth="0.882716"
          />
        </g>
        <rect
          x="242.464"
          y="29.116"
          width="97.9358"
          height="115.284"
          rx="9.4"
          stroke="black"
          strokeWidth="1.2"
        />
        <path d="M246.5 143.088L235 132.091" stroke="black" strokeWidth="1.2" />
        <rect
          x="231.6"
          y="18.6"
          width="97.9358"
          height="115.284"
          rx="9.4"
          fill="white"
          stroke="black"
          strokeWidth="1.2"
        />
        <path d="M326 20.7493L337.5 31.2878" stroke="black" strokeWidth="1.2" />

        <g clipPath="url(#clip1_5720_94548)">
          <rect
            x="24.8643"
            y="28.516"
            width="99.1358"
            height="116.484"
            rx="10"
            fill="white"
          />
          <line
            x1="8.01848"
            y1="145.214"
            x2="144.16"
            y2="9.07221"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="5.94914"
            y1="143.145"
            x2="142.091"
            y2="7.00348"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="3.8803"
            y1="141.076"
            x2="140.022"
            y2="4.93476"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="1.81194"
            y1="139.007"
            x2="137.954"
            y2="2.86591"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-0.256423"
            y1="136.939"
            x2="135.885"
            y2="0.79706"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-2.32527"
            y1="134.87"
            x2="133.816"
            y2="-1.27167"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="10.0873"
            y1="147.282"
            x2="146.229"
            y2="11.1408"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="12.1552"
            y1="149.351"
            x2="148.297"
            y2="13.2098"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="14.2245"
            y1="151.42"
            x2="150.366"
            y2="15.2785"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="16.2934"
            y1="153.489"
            x2="152.435"
            y2="17.3472"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="18.3622"
            y1="155.557"
            x2="154.504"
            y2="19.4158"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="20.4306"
            y1="157.626"
            x2="156.572"
            y2="21.4847"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="22.4994"
            y1="159.695"
            x2="158.641"
            y2="23.5535"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="24.5683"
            y1="161.764"
            x2="160.71"
            y2="25.6223"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="36.9809"
            y1="174.176"
            x2="173.122"
            y2="38.0347"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="34.912"
            y1="172.107"
            x2="171.054"
            y2="35.9659"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="32.8432"
            y1="170.039"
            x2="168.985"
            y2="33.8972"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="30.7743"
            y1="167.97"
            x2="166.916"
            y2="31.8286"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="28.706"
            y1="165.901"
            x2="164.848"
            y2="29.7596"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="26.6371"
            y1="163.833"
            x2="162.779"
            y2="27.691"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="39.0492"
            y1="176.245"
            x2="175.191"
            y2="40.1035"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="41.1181"
            y1="178.314"
            x2="177.26"
            y2="42.1722"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="43.1869"
            y1="180.382"
            x2="179.329"
            y2="44.2409"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="45.2558"
            y1="182.451"
            x2="181.397"
            y2="46.3096"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="47.3241"
            y1="184.52"
            x2="183.466"
            y2="48.3785"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="49.393"
            y1="186.589"
            x2="185.535"
            y2="50.4473"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="51.4618"
            y1="188.658"
            x2="187.603"
            y2="52.5159"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="53.5307"
            y1="190.726"
            x2="189.672"
            y2="54.5847"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="74.7729"
            y1="194.546"
            x2="201.246"
            y2="68.0724"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="72.7035"
            y1="192.477"
            x2="199.177"
            y2="66.0037"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="70.6347"
            y1="190.408"
            x2="197.108"
            y2="63.935"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="68.5663"
            y1="188.34"
            x2="195.04"
            y2="61.8661"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="66.498"
            y1="186.271"
            x2="192.971"
            y2="59.7974"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="64.4291"
            y1="184.202"
            x2="190.903"
            y2="57.7286"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="76.8417"
            y1="196.615"
            x2="203.315"
            y2="70.141"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="78.9096"
            y1="198.683"
            x2="205.383"
            y2="72.2099"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="80.9789"
            y1="200.752"
            x2="207.452"
            y2="74.2787"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="83.0478"
            y1="202.821"
            x2="209.521"
            y2="76.3475"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="85.1166"
            y1="204.89"
            x2="211.59"
            y2="78.4161"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="87.185"
            y1="206.958"
            x2="213.658"
            y2="80.4849"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="89.2538"
            y1="209.027"
            x2="215.727"
            y2="82.5536"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="91.3227"
            y1="211.096"
            x2="217.796"
            y2="84.6224"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="103.735"
            y1="223.508"
            x2="230.209"
            y2="97.0348"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="101.666"
            y1="221.44"
            x2="228.14"
            y2="94.9661"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="99.5976"
            y1="219.371"
            x2="226.071"
            y2="92.8974"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="97.5287"
            y1="217.302"
            x2="224.002"
            y2="90.8287"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="95.4604"
            y1="215.233"
            x2="221.934"
            y2="88.7598"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="93.3915"
            y1="213.165"
            x2="219.865"
            y2="86.6912"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="105.804"
            y1="225.577"
            x2="232.277"
            y2="99.1037"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="107.872"
            y1="227.646"
            x2="234.346"
            y2="101.172"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="109.941"
            y1="229.715"
            x2="236.415"
            y2="103.241"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="112.01"
            y1="231.783"
            x2="238.484"
            y2="105.31"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="114.079"
            y1="233.852"
            x2="240.552"
            y2="107.379"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="116.147"
            y1="235.921"
            x2="242.621"
            y2="109.447"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="118.216"
            y1="237.99"
            x2="244.69"
            y2="111.516"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="120.285"
            y1="240.058"
            x2="246.759"
            y2="113.585"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-69.3004"
            y1="59.0596"
            x2="57.1731"
            y2="-67.4139"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-72.4215"
            y1="55.9388"
            x2="54.0521"
            y2="-70.5348"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-75.5421"
            y1="52.8178"
            x2="50.9314"
            y2="-73.6557"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-78.6627"
            y1="49.6969"
            x2="47.8108"
            y2="-76.7766"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-81.7838"
            y1="46.5761"
            x2="44.6898"
            y2="-79.8974"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-84.9049"
            y1="43.4552"
            x2="41.5687"
            y2="-83.0183"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-66.1793"
            y1="62.1805"
            x2="60.2942"
            y2="-64.2931"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-63.0587"
            y1="65.3013"
            x2="63.4148"
            y2="-61.1722"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-59.9376"
            y1="68.4223"
            x2="66.5359"
            y2="-58.0512"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-56.817"
            y1="71.5431"
            x2="69.6565"
            y2="-54.9304"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-53.6959"
            y1="74.664"
            x2="72.7776"
            y2="-51.8095"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-50.5753"
            y1="77.7848"
            x2="75.8982"
            y2="-48.6887"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-47.4542"
            y1="80.9057"
            x2="79.0193"
            y2="-45.5678"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-44.3336"
            y1="84.0265"
            x2="82.1399"
            y2="-42.447"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-25.608"
            y1="102.752"
            x2="100.866"
            y2="-23.7216"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-28.7291"
            y1="99.6309"
            x2="97.7444"
            y2="-26.8426"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-31.8502"
            y1="96.5101"
            x2="94.6233"
            y2="-29.9635"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-34.9708"
            y1="93.3892"
            x2="91.5027"
            y2="-33.0843"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-38.0914"
            y1="90.2684"
            x2="88.3821"
            y2="-36.2052"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-41.2125"
            y1="87.1475"
            x2="85.261"
            y2="-39.326"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-22.4874"
            y1="105.873"
            x2="103.986"
            y2="-20.6008"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-19.3663"
            y1="108.994"
            x2="107.107"
            y2="-17.4799"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-16.2457"
            y1="112.114"
            x2="110.228"
            y2="-14.3591"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-13.1246"
            y1="115.235"
            x2="113.349"
            y2="-11.2382"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-10.0035"
            y1="118.356"
            x2="116.47"
            y2="-8.11739"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-6.88289"
            y1="121.477"
            x2="119.591"
            y2="-4.99642"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-3.76228"
            y1="124.598"
            x2="122.711"
            y2="-1.87557"
            stroke="black"
            strokeWidth="0.882716"
          />
          <line
            x1="-0.641189"
            y1="127.719"
            x2="125.832"
            y2="1.24528"
            stroke="black"
            strokeWidth="0.882716"
          />
        </g>
        <rect
          x="25.4643"
          y="29.116"
          width="97.9358"
          height="115.284"
          rx="9.4"
          stroke="black"
          strokeWidth="1.2"
        />
        <path d="M29.5 143.088L18 132.091" stroke="black" strokeWidth="1.2" />
        <rect
          x="14.6"
          y="18.6"
          width="97.9358"
          height="115.284"
          rx="9.4"
          fill="white"
          stroke="black"
          strokeWidth="1.2"
        />
        <path d="M109 20.7491L120.5 31.2877" stroke="black" strokeWidth="1.2" />
        <rect x="79" y="-4" width="189" height="189" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_5720_94548"
            transform="translate(-0.388889) scale(0.000925926)"
          />
        </pattern>
        <clipPath id="clip0_5720_94548">
          <rect
            x="241.864"
            y="28.516"
            width="99.1358"
            height="116.484"
            rx="10"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_5720_94548">
          <rect
            x="24.8643"
            y="28.516"
            width="99.1358"
            height="116.484"
            rx="10"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default FirstBackground;
